import { render, staticRenderFns } from "./EditCampaignLoader.vue?vue&type=template&id=b24411a6"
import script from "./EditCampaignLoader.vue?vue&type=script&lang=ts"
export * from "./EditCampaignLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports